<template>
    <v-dialog     fullscreen
                  hide-overlay
                  transition="dialog-bottom-transition"
                  v-model="is_visible">
        <v-card style="border-radius: 0px">
            <v-toolbar
                    dark
                    color="black"
            >
                <v-btn
                        icon
                        dark
                        @click="close_text_settings"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>Text Settings</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn
                            dark
                            text
                            @click="close_text_settings"
                    >
                        Close Options
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-card-text>
                <v-card>
                    <v-card-title>
                        Preview
                    </v-card-title>
                    <v-card-text class="text-center">
                        <div

                                :style="'color:'+item.text_color+'; position:relative;'"
                                :class="' content ' + item.classes + ' mb-12'">
                        <span
                                v-html="item.content"
                                :class="{'font-weight-bold': item.bold === true,
                                 'font-italic': item.italic === true,
                                 'text-uppercase' : item.uppsercase,
                                 'text-lowercase' : item.lowercase,
                                 'underline': item.underline === true, 'text-shadow': item.shadow === true }">

                            </span>
                        </div>

                    </v-card-text>
                </v-card>
                <v-divider class="mt-12 mb-6"></v-divider>

                 <v-container>
                     <v-row>
                         <v-col cols="12" sm="12" md="12" lg="12">
                           {{ item.classes }}
                             <v-select
                                     v-model="item.classes"
                                     :items="sizes"
                                     item-value="id"
                                     item-text="name"
                                     label="Font Size"
                             ></v-select>
                         </v-col>
                         <v-col cols="12" sm="4" md="3">
                             <v-switch
                                     v-model="item.shadow"
                                     label="Text Shadow"
                             ></v-switch>

                             <v-switch
                                     v-model="item.bold"
                                     label="Bold"
                             ></v-switch>

                             <v-switch
                                     v-model="item.underline"
                                     label="Underline"
                             ></v-switch>

                             <v-switch
                                     v-show="!item.lowercase"
                                     v-model="item.uppercase"
                                     label="Uppercase"
                             ></v-switch>

                             <v-switch
                                     v-show="!item.uppercase"
                                     v-model="item.lowercase"
                                     label="Lowercase"
                             ></v-switch>
                         </v-col>
                         <v-col cols="12" sm="4" md="3">
                             <p class="body-1">
                                 Text Color
                             </p>
                             <v-color-picker
                                     dark
                                     flat
                                     v-model="item.text_color"
                                     :hide-canvas="false"
                                     :hide-inputs="false"
                                     :hide-mode-switch="false"
                                     :canvas-height="150"
                                     :show-swatches="false"
                                     class="mx-auto"
                             ></v-color-picker>

                         </v-col>
                     </v-row>
                 </v-container>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>

    export default {
        props: {
            is_visible: Boolean,
            item: Object,
            close_text_settings: Function
        },
        components: {},
        data() {
            return {
                size: 'display-4',
                sizes: [
                    {
                        id: 'text-h2 text-lg-h1',
                        name: 'H1'
                    },
                    {
                        id: 'text-h3 text-lg-h2',
                        name: 'H2'
                    },
                    {
                        id: 'text-h4 text-lg-h3',
                        name: 'H3'
                    },
                    {
                        id: 'text-h4',
                        name: 'H4'
                    },
                    {
                        id: 'headline',
                        name: 'Headline'
                    },
                    {
                        id: 'body-1',
                        name: 'Body'
                    },
                    {
                        id: 'body-2',
                        name: 'Body Small'
                    },

                ]
            }
        },
        methods: {

        }
    }
</script>
